import {all, fork} from "redux-saga/effects";
import * as Dashboard from "./dashboard.saga";
import * as Group from "./group.saga";
import * as Inventory from "./inventory.saga";
import * as InventoryReports from "./inventoryReports.saga";
import * as Login from "./login.saga";
import * as Jobs from "./jobs.saga";
import * as Notifications from "./notifications.saga";
import * as Orgs from "./organization.saga";
import * as Sims from "./sim.saga";
import * as Users from "./users.saga";

export default function* rootSaga() {
  yield all(
    [
      ...Object.values(Dashboard),
      ...Object.values(Group),
      ...Object.values(Inventory),
      ...Object.values(InventoryReports),
      ...Object.values(Login),
      ...Object.values(Jobs),
      ...Object.values(Notifications),
      ...Object.values(Orgs),
      ...Object.values(Sims),
      ...Object.values(Users),
    ].map(fork)
  );
}
